/**
 * <sg-recommendations>: lädt Produktempfehlungen über die Section Rendering API
 * (nicht bei data-static, dann stehen die Produkte schon aus dem Metafield im HTML),
 * sobald die Section in die Nähe des Viewports kommt. Erst „ergänzende“ Produkte
 * (Search & Discovery), bei leerem Ergebnis optional „ähnliche“ Produkte.
 */
class SgRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-static')) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load(this.dataset.intent || 'related');
      },
      { rootMargin: '0px 0px 400px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load(intent) {
    try {
      const response = await fetch(`${this.dataset.url}&intent=${intent}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = html.querySelector('sg-recommendations');
      const content = section ? section.innerHTML.trim() : '';
      if (content) {
        this.innerHTML = content;
      } else if (intent === 'complementary' && this.hasAttribute('data-fallback')) {
        this.load('related');
      }
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('sg-recommendations', SgRecommendations);
